import PropTypes from "prop-types";

const EllipseBlur = ({
    width,
    height,
    borderRadius,
    opacity,
    background,
    blur,
}) => {
    return null;
};

EllipseBlur.defaultProps = {
    width: "682px",
    height: "682px",
    borderRadius: "50%",
    opacity: "0.08",
    background: "#ff5300",
    blur: "250px",
};

EllipseBlur.propTypes = {
    width: PropTypes.string,
    height: PropTypes.string,
    borderRadius: PropTypes.string,
    opacity: PropTypes.string,
    background: PropTypes.string,
    blur: PropTypes.string,
};

export default EllipseBlur;
